/** @jsx jsx */
import { jsx, Box } from 'theme-ui'

const Hero = props => (
  <Box
    {...props}
    sx={{
      backgroundColor: 'gray.8',
      color: 'white',
      overflow: 'hidden',
      position: 'relative',
      zIndex: 0,
    }}
  >
    {props.children}
  </Box>
)

export default Hero
